import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import mimeDB from 'mime-db';
import i18next from 'core/i18n';
import { AgFinancing, AgFinancingDocumentType, AgStateName, Phase2 } from '@indigo-ag/schema';
import { SelectOption } from '@indigo-ag/component-module';
import { ICollateralAnalysisInfo } from '../models';

interface IDocument {
  documentUrl: string;
  documentName: string;
}

export const downloadFile = ({ documentUrl, documentName }: IDocument) =>
  getDocumentBlob({ documentUrl, documentName }).then(async res => saveAs(await res.blob(), documentName));

export const downloadFilesAsZip = async (documents: IDocument[]) => {
  const zip = new JSZip();

  for (const { documentName, documentUrl } of documents) {
    const response = await getDocumentBlob({ documentUrl, documentName });

    const docNameHasExtension = /\.\w+$/.test(documentName);
    const contentType = response.headers.get('Content-Type') || '';
    const extensions = (!!contentType && mimeDB[contentType]?.extensions) || [''];
    const docName = docNameHasExtension || !extensions[0] ? documentName : `${documentName}.${extensions[0]}`;

    zip.file(docName, response.blob());
  }

  return zip.generateAsync({ type: 'blob' }).then(zipFile => {
    const fileName = 'documents.zip';
    saveAs(zipFile, fileName);
  });
};

const getDocumentBlob = ({ documentUrl, documentName }: IDocument) =>
  fetch(documentUrl).then(response => {
    if (!response.ok) {
      throw new Error(i18next.t('downloadDocumentError', { file: documentName }));
    }

    return response;
  });

export const validatePhase2Documents = (options: SelectOption[], agFinance?: AgFinancing): SelectOption[] => {
  if (!agFinance?.currentStates?.includes(AgStateName.PHASE_2)) {
    options = options.filter(option => option.value !== AgFinancingDocumentType.BALANCE_DRE);
  }

  return options;
};

export const getAnalysisData = (matriculas: Phase2['matriculas']): ICollateralAnalysisInfo | undefined => {
  if (matriculas) {
    return {
      matriculas
    };
  }
  return undefined;
};
